class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            // Attach add-to-cart handlers for the newly loaded forms
            // ['bz-cart-sidebar', 'cart-popup'].forEach(selector => {
            //   const bzCartWrap = document.querySelector(selector);
            //   if (bzCartWrap) {
            //     this.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
            //       bzCartWrap.attachAddToCart(form);
            //     });
            //   }
            // });
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);